<template>
  <div id="app">
    <div id='header'>
      <router-link :to=" '/' + this.$route.params.token " v-if='this.$route.params.token'><img alt="logo" src="./assets/logo3.png" ></router-link>
      <router-link :to=" '/' " v-if='!this.$route.params.token'><img alt="logo" src="./assets/logo3.png" ></router-link>
      <div id='nav' >

        <router-link :to=" '/user/' + this.$route.params.token " v-if='this.$route.params.token'>DITT KONTO</router-link>
        <router-link :to=" '/contact/' + this.$route.params.token " v-if='this.$route.params.token'>KONTAKT</router-link>
        <router-link :to=" '/contact/' " v-if='!this.$route.params.token'>KONTAKT</router-link>
      </div>
    </div>
    <router-view @on-showLogout="showLogout()" @on-hideLogout="hideLogout()"></router-view>
  <div class='section' id='footer'><h3 :title='hostname'>&copy; 2019 Min Trängselskatt <br/> Keeping Transportstyrelsen busy since 2013 <br/> www.mintrangselskatt.se</h3><br>

  <img alt="logo" src="./assets/logo3.png" style='clear:both;width:300px;margin:20px;'><br><br>
    <div style='background:white;display:inline-block;margin:auto 0;padding:10px;border-radius:10px;'>
     <facebook url="https://www.mintrangselskatt.se" scale="3" style='margin:10px;'></facebook> 
     <Twitter url="https://www.mintrangselskatt.se" scale="3" style='margin:10px;'></Twitter>
     <Linkedin url="https://www.mintrangselskatt.se" scale="3" style='margin:10px;'></Linkedin>
     <WhatsApp url="https://www.mintrangselskatt.se" scale="3" style='margin:10px;'></WhatsApp>
     <Email url="https://www.mintrangselskatt.se" scale="3" style='margin:10px;'></Email>
     
  </div><br>
    <br/><br/>
  
  
    <div class='column'>
    </div>
  </div>
  </div>
</template>

<script>



import { Facebook, Twitter, Linkedin, WhatsApp, Email } from "vue-socialmedia-share";



export default {
  name: 'app',
  components: {
        Facebook,  Twitter, Linkedin, WhatsApp, Email 
    

  },
  data: function(){
    return {
      hostname: this.$hostname,
    }
  }
}
</script>

<style>

@import url('https://fonts.googleapis.com/css?family=Montserrat');

#app {
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height:100%;
  width:100%;

}
html{
  height: 100%;
  width:100%;
}
html body{
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  background-color: black;
  margin:0;
  padding:0;
  width:100%;
  height:100%;
}

#header{
  background-color: #404040;
  color:white;
  text-align:left;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
  height: 75px;
}

  #header img{
    position: absolute;
    display: block;
    float:left;
    max-width:75px;
    height:auto;
    margin-left:10px;
  }

div#main{
  background: url(./assets/bg-blur.png) center center transparent fixed no-repeat ;
  background-size: cover;
  text-align: center;
  padding:20px;
  padding-left:0px;
  padding-right:0px;

}

div#main div#content{

  text-align: left;
  display: inline-block;
  background:black;
  border-radius: 3px;
  
    
}

@media screen and (min-width: 1300px)  {

  #header img{
    float:left;
    max-width:150px;
    height:auto;
    margin-left:10px;
  }


  div#main{
      padding:20px;

  }

  div#main div#content{
    border-radius: 10px; 
  }
}


#header #nav{
  float:right;
  margin-top:10px;
  margin-right:50px;
  padding-top:16px;
}

#header #nav a, #header #nav a:visited{
  color: white;
  text-decoration: none;
  margin:10px;
}


div.section{
    text-align:center;
    background:#404040;
    color:white;
    padding:10px;
}

div.section div.column{
  display: inline-block;
  background: transparent;
  text-align: left;
  color:white;
}

div.column{
  max-width: 900px;
  width:100%;
  color:white;
  
}

div#footer{
  background:#0083e5;
  }


a.anchor {
    display: block;
    position: relative;
    top: -60px;
    visibility: hidden;
}

div.messageWrapper{
  min-height:40px;
  margin-top:20px;
  background:transparent;

}

h1{
  color:white;
  font-size: calc(12px + 2vw);
}

.message{
    background-color: rgb(112, 112, 112);
    padding: 10px;
    color:white;
    border-radius: 10px;
    font-size: calc(16px + 0.4vw);
    
}

input, button{
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
}

</style>

<style scoped>


</style>
